// TelcoTrack — Databáze. Saved profile `sections.database.view`.

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { permissionAllows } from '@core/shared-bridge';

export const superadminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.getCurrentUser();
  if (permissionAllows(user?.permissionProfile, 'database', 'view')) {
    return true;
  }
  return router.createUrlTree(['/403']);
};
